import React, { useImperativeHandle } from "react";
import { useDebounceFn, useRequest, useUpdateEffect } from "ahooks";
import { useGlobalState } from "@/GlobalProvider";
import { useTranslation } from "@/langs/useTranslation";
import { getScheduleEventDevices } from "@/apis/apiCollection";
import Autocomplete from "../Autocomplete";

const DeviceSerialNumberSelector = React.forwardRef(
  ({ disabled, name, value, onChange }, ref) => {
    const { t } = useTranslation();
    const { currentCompanyId } = useGlobalState();
    const {
      data = { data: [] },
      loading,
      run
    } = useRequest(params =>
      getScheduleEventDevices({ keywords: params?.keywords, hasSchedule: 1 })
    );

    useUpdateEffect(run, [currentCompanyId]);

    useImperativeHandle(ref, () => ({
      getOptions: () => data.data
    }));

    const { run: handleInputChange } = useDebounceFn(
      (e, reason) => {
        if (reason === "input" || reason === "clear") {
          run({ keywords: e.target.value });
        }
      },
      { wait: 300 }
    );

    return (
      <Autocomplete
        placeholder={t({ defaultMessage: "输入设备SN" })}
        options={data.data.map(item => ({
          id: item.id,
          name: item.serial_number
        }))}
        disabled={disabled}
        loading={loading}
        name={name}
        value={value}
        onChange={onChange}
        onInputChange={handleInputChange}
        style={{ width: 300 }}
      />
    );
  }
);

export default DeviceSerialNumberSelector;
